import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {"color":"red"},
  class: "frame"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr_stream = _resolveComponent("qr-stream")!

  return (_openBlock(), _createBlock(_component_qr_stream, {
    camera: "rear",
    onDecode: _ctx.callback,
    class: "mb"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["onDecode"]))
}